import * as url from "../../helpers/url_helper";
import { apiCall } from "./apiService";

/**
 * Loads scanner websites from API with error handling
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Array|null>} Array of scanner websites or null if error
 */
export const loadScannerWebsitesData = async (notifyError) => {
    return await apiCall(
        url.COUPON_SCANNER_WEBSITE,
        'GET',
        null,
        notifyError,
        "Failed to load scanner websites"
    );
};

/**
 * Creates a new scanner website
 * @param {Object} websiteData - Scanner website data
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Created scanner website data or null if error
 */
export const createScannerWebsite = async (websiteData, notifyError) => {
    return await apiCall(
        url.COUPON_SCANNER_WEBSITE,
        'POST',
        websiteData,
        notifyError,
        "Scanner Website creation failed"
    );
};

/**
 * Updates an existing scanner website
 * @param {Object} websiteData - Scanner website data with id
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Updated scanner website data or null if error
 */
export const updateScannerWebsite = async (websiteData, notifyError) => {
    return await apiCall(
        url.COUPON_SCANNER_WEBSITE,
        'PUT',
        websiteData,
        notifyError,
        "Scanner Website update failed"
    );
};

